import React from "react";
var __jsx = React.createElement;
import stl from "./RequiredDocuments.module.css";
import { useTranslation } from '@i18n';
import { useState } from 'react';
import SharedPopUp from '@componentsShared/BottomSheetPopup__OLD/SharedPopUp';
import financingConditionsRequiredDocuments from "@data/financing-conditions-and-required-documents/data.json";
import { useLang } from "@/common/Contexts/LanguageContext";
import { twMerge } from "tailwind-merge";
import HowToFinanceContent from "@/pages/checkout/pre-checkout/how-to-finance/HowToFinanceContent";
import { BottomSheet } from "@componentsShared/BottomSheet";
import useBoolean from "@hooks/useBoolean";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { trackEvents } from "@/common/events/events";
import useCheckABFlag from "@hooks/useCheckABFlag";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
var RequiredDocuments = function RequiredDocuments(_ref) {
  var _useCheckoutOrder, _useCheckoutOrder$sta, _useAribFinance;
  var blueStyle = _ref.blueStyle,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _useState2 = useState(0),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var checkoutOrder = (_useCheckoutOrder = useCheckoutOrder()) === null || _useCheckoutOrder === void 0 ? void 0 : (_useCheckoutOrder$sta = _useCheckoutOrder.state) === null || _useCheckoutOrder$sta === void 0 ? void 0 : _useCheckoutOrder$sta.checkoutOrder;
  var aribOrder = (_useAribFinance = useAribFinance()) === null || _useAribFinance === void 0 ? void 0 : _useAribFinance.state;
  console.log(aribOrder);
  var _useState3 = useState(financingConditionsRequiredDocuments[lang]),
    data = _useState3[0],
    setData = _useState3[1];
  var financeModal = useBoolean();
  var AB_FINANCE_UX_ENHANCEMENT = useCheckABFlag("AB_FINANCE_UX_ENHANCEMENT");
  if (data.length === 0) return null;
  var handleMoreClick = function handleMoreClick() {
    setShowPopUp(true);
  };
  var getIsCarNew = function getIsCarNew() {
    if (aribOrder && aribOrder !== null && aribOrder !== void 0 && aribOrder.postData) {
      var _aribOrder$postData;
      return (aribOrder === null || aribOrder === void 0 ? void 0 : (_aribOrder$postData = aribOrder.postData) === null || _aribOrder$postData === void 0 ? void 0 : _aribOrder$postData.post_condition) === 'new';
    } else {
      var _checkoutOrder$detail, _checkoutOrder$detail2;
      return !!(checkoutOrder !== null && checkoutOrder !== void 0 && (_checkoutOrder$detail = checkoutOrder.details_card) !== null && _checkoutOrder$detail !== void 0 && (_checkoutOrder$detail2 = _checkoutOrder$detail.is_new) !== null && _checkoutOrder$detail2 !== void 0 && _checkoutOrder$detail2.id);
    }
  };
  var getCheckoutOrder = function getCheckoutOrder() {
    if (aribOrder && aribOrder !== null && aribOrder !== void 0 && aribOrder.postData) {
      var _aribOrder$postData2;
      return aribOrder === null || aribOrder === void 0 ? void 0 : (_aribOrder$postData2 = aribOrder.postData) === null || _aribOrder$postData2 === void 0 ? void 0 : _aribOrder$postData2.g4Data;
    } else {
      return checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer;
    }
  };
  var openFinanceRequirementsModal = function openFinanceRequirementsModal() {
    if (AB_FINANCE_UX_ENHANCEMENT) {
      financeModal.setTrue();
      trackEvents("finance_info_clicked", {
        referral_location: "initial-form"
      });
    } else {
      setShowPopUp(true);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ["rounded-md border border-[#f4e9ce] bg-[#fff9ea] p-3 flex items-center mt-8 gap-[7px] cursor-pointer border-solid", blueStyle ? "!border-none bg-[#f1f7ff]" : undefined, className !== null && className !== void 0 ? className : undefined].join(" "),
    onClick: function onClick() {
      return openFinanceRequirementsModal();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: [stl.BGIcon, "block bg-no-repeat bg-center w-6 h-6"].join(" ")
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#154f9c] text-xs font-bold leading-6"
  }, t("validation_what_financing_requirements_required_documents", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154f9c] text-[10px] font-semibold leading-4 underline justify-self-end ar:mr-auto en:ml-auto"
  }, t("learn", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement(BottomSheet, {
    open: financeModal.value,
    onOpen: financeModal.setTrue,
    onClose: financeModal.setFalse,
    maxHeight: "95%",
    hideTitleBar: true,
    haveClose: true,
    maxWidthDesktop: '60%',
    maxHeightDesktop: !!(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_is_new) ? "90%" : "fit-content",
    screens: [{
      title: tShort('pre-checkout/requirements_title', {
        ns: 'web_post_view'
      }),
      component: /*#__PURE__*/React.createElement(HowToFinanceContent, {
        isNew: getIsCarNew(),
        g4Data: getCheckoutOrder()
      })
    }]
  }), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-[35px] flex flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-[#154f9c] text-2xl font-bold leading-8 mt-6 mb-6"
  }, t("validation_financing_requirements_required_documents", {
    ns: "web_checkout_finance"
  }), " "), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, data === null || data === void 0 ? void 0 : data.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      onClick: function onClick() {
        return setActiveTab(index);
      },
      className: ["w-1/2 rounded-md bg-[#f1f6fc] h-10 flex items-center justify-center text-[#6c7a8d] text-sm font-semibold leading-6", activeTab == index ? twMerge("!bg-[#154f9c] text-white font-bold pointer-events-none") : undefined].join(" ")
    }, item.name);
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.RDTabsBody
  }, data === null || data === void 0 ? void 0 : data.map(function (item, index) {
    return activeTab === index && /*#__PURE__*/React.createElement("div", {
      className: stl.RDlistsContainer,
      key: index
    }, item.bulleted_list.map(function (innerItem, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement("strong", {
        className: "mt-6 mb-[10px] block text-[#154f9c] text-base font-bold leading-6"
      }, innerItem.title), /*#__PURE__*/React.createElement("ul", {
        className: "list-[square] px-5"
      }, innerItem.list_items.split('\n').map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: "text-[#484848] text-sm font-semibold leading-6",
          key: index,
          dangerouslySetInnerHTML: {
            __html: item
          }
        });
      })));
    }));
  }))))));
};
export default RequiredDocuments;